/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {service as EnvironmentalBenefitService} from "../../../Services/EnvironmentalBenefitService";
import {UnitNumberFieldEditor} from "./UnitNumberFieldEditor";
import React from "react";

export function EnvironmentalBenefitValueEditor(props) {
	usePrimeCache(EnvironmentalBenefitService);
	const {environmentalBenefitId = -1} = props;
	const environmentalBenefit = EnvironmentalBenefitService.CachedValueById(environmentalBenefitId)?.result;
	return <UnitNumberFieldEditor
		{...props}
		unitId={environmentalBenefit?.unitId}
	/>;
}